import { Title as ReactAdminTitle } from "react-admin";

const AppBarTitle = ReactAdminTitle;

export default AppBarTitle;
